import { Link } from "react-router-dom";
import { getTopEvents } from "@/utils/content";
import { stats } from "@/mocks/site";

export default function HeroSection() {
  const top = getTopEvents(5);
  const today = new Date();
  const dateLabel = `${today.getFullYear()} 年 ${today.getMonth() + 1} 月 ${today.getDate()} 日`;

  return (
    <section className="relative w-full overflow-hidden border-b border-background-200/70 bg-background-50">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 right-1/4 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl"></div>

      <div className="relative grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-12 lg:gap-14 lg:py-24">
        <div className="animate-rise lg:col-span-7">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-800">
            <i className="ri-water-flash-line"></i>
            今日瓜单 · {dateLabel}
          </p>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl lg:text-6xl">
            1每日吃瓜
            <span className="mt-3 block font-heading text-2xl font-semibold text-foreground-700 md:text-3xl lg:text-4xl">
              每日一站，吃遍全网大瓜
            </span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            我们每天梳理 <strong className="font-semibold text-foreground-900">1每日吃瓜热门事件</strong>，
            汇总 <strong className="font-semibold text-foreground-900">1每日吃瓜大瓜汇总</strong>，
            并以 <strong className="font-semibold text-foreground-900">1每日吃瓜本周瓜单</strong> 呈现焦点走向。
            从剧集到综艺，从音乐现场到全网热议，几分钟看清事件脉络。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/events"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              浏览热门事件
            </Link>
            <Link
              to="/roundup"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-list-ordered"></i>
              查看本周瓜单
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-4 border-t border-background-200/80 pt-6 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950">
                  {item.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-500">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-bar-chart-2-line"></i>
                </span>
                今日热度榜
              </h2>
              <span className="text-xs text-foreground-500">实时更新</span>
            </div>
            <ol className="mt-5 space-y-1">
              {top.map((item, idx) => (
                <li key={item.slug}>
                  <Link
                    to={`/events/${item.slug}`}
                    className="flex items-start gap-3 rounded-md px-2 py-3 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        idx < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-2 block text-sm font-medium leading-snug text-foreground-900">
                        {item.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                          {item.category}
                        </span>
                        <span className="flex items-center gap-0.5">
                          <i className="ri-fire-line text-primary-500"></i>
                          {item.heat.toFixed(1)}
                        </span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/roundup"
              className="mt-4 flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-foreground-950 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              查看完整本周瓜单
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}